export const mailStates = ['Needs action', 'Needs classification', 'Waiting for someone', 'Resolved', 'Historic'] as const;
const allowedQueues = ['unanswered','assigned', 'unassigned', 'waiting-reply', 'resolved', 'attention', 'overdue', 'proposals', 'drafts', 'follow-up', 'failed', 'archived'];

/** Search stays in the history entry; only non-sensitive controls are shareable. */
export function mailQueueHref(search: string, building?: string) {
  const source = new URLSearchParams(search), params = new URLSearchParams();
  if (building) params.set('building', building);
  if (building && source.get('request') === 'property-schedule') params.set('request', 'property-schedule');
  if (allowedQueues.includes(source.get('queue') ?? '')) params.set('queue', source.get('queue')!);
  if (!params.has('queue') && mailStates.includes(source.get('state') as typeof mailStates[number])) params.set('state', source.get('state')!);
  const account = source.get('accountId');
  if (account && account.length <= 100) params.set('accountId', account);
  const page = Number(source.get('page'));
  if (Number.isSafeInteger(page) && page > 1 && page <= 20001) params.set('page', String(page));
  return `/communications${params.size ? `?${params}` : ''}`;
}

export function privateMailSearch(state: unknown): string {
  const value = state && typeof state === 'object' && 'mailSearch' in state ? state.mailSearch : undefined;
  return typeof value === 'string' ? value.slice(0, 200) : '';
}

export function mailReturnContext(state: unknown, building?: string) {
  if (!state || typeof state !== 'object' || !('mailReturn' in state)) return undefined;
  const value = state.mailReturn;
  if (!value || typeof value !== 'object' || !('to' in value) || typeof value.to !== 'string') return undefined;
  if (!value.to.startsWith('/communications') || value.to.startsWith('//')) return undefined;
  const url = new URL(value.to, 'https://staff.invalid');
  if (url.origin !== 'https://staff.invalid' || url.pathname !== '/communications' || url.hash) return undefined;
  if ([...url.searchParams.keys()].some(key => !['building', 'queue', 'accountId', 'page', 'request'].includes(key) || url.searchParams.getAll(key).length !== 1)) return undefined;
  if ((url.searchParams.get('building') ?? undefined) !== building) return undefined;
  if (url.searchParams.has('request') && (!building || url.searchParams.get('request') !== 'property-schedule')) return undefined;
  return { to: mailQueueHref(url.search, building),
    search: 'search' in value && typeof value.search === 'string' ? value.search.slice(0, 200) : '',
    focusKey: 'focusKey' in value && typeof value.focusKey === 'string' ? value.focusKey.slice(0, 200) : '' };
}

export function mailRowId(id: string) { return `mail-${encodeURIComponent(id)}`; }

export function captureLensReturnContext(state:unknown,building?:string){
  const value=state&&typeof state==='object'&&'captureLensReturn' in state?state.captureLensReturn:null;
  if(!value||typeof value!=='object'||!('search' in value)||typeof value.search!=='string'||value.search.length>1000)return undefined;
  const params=new URLSearchParams(value.search);
  if([...params.keys()].some(key=>!['building','state','page','from','to','domain','matter','urgency','workflow','confidence','senderDomain'].includes(key)||params.getAll(key).length!==1))return undefined;
  if((params.get('building')??undefined)!==building)return undefined;
  const sender='sender' in value&&typeof value.sender==='string'?value.sender.slice(0,320):'';
  return {to:`/communications/lens${params.size?`?${params}`:''}`,sender};
}
